import Logger from '../lib/logger';

const scrollLockState = {
  scrollY: 0,
  bodyStyles: null,
  htmlOverflow: '',
};

class DharmaModal extends HTMLElement {
  #NAME = `DharmaModal`;
  abortController;
  #main
  #contentType = 'content';

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    let template = document.getElementById('dharma-modal-template');
    let templateContent = template.content;
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(templateContent.cloneNode(true));
    this.#main = this.shadowRoot.querySelector('main');
    this.closeBtn = this.shadowRoot.querySelector('[data-close-btn]');
  }

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.closeBtn.addEventListener('click', () => this.dataset.show = 'false');
  }

  disconnectedCallback() {
    this.unlockScreen();

    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  static get observedAttributes() {
    return ['content-type', 'data-show', 'lock-screen', 'modal-style'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    Logger.info(`${this.#NAME} > attributeChangedCallback > ${name}, ${oldValue}, ${newValue}`);
    switch (name) {
      case 'data-show':
        this.dispatchCustomEvent(newValue === 'false' ? 'close' : 'open');
        if (newValue === 'true') {
          this.lockScreen();
          this.content?.scrollTo({top: 0, behavior: 'instant'});
        } else {
          this.unlockScreen();
        }
        break;

      case 'lock-screen':
        if (this.dataset.show === 'true') {
          newValue === null ? this.unlockScreen() : this.lockScreen();
        }
        break;

      case 'content-type':
        this.#contentType = newValue;
        setTimeout(() => {
          this.content = this.querySelector('[slot="modal-content"]');
          this.addButtonListeners();
        }, 20);
        break;

      case 'modal-style':
        if (newValue && newValue !== '') {
          this.#main.setAttribute('style', newValue);
        }
        break;
    
      default:
        break;
    }
  }

  lockScreen() {
    if (!this.hasAttribute('lock-screen') || document.body.classList.contains('dharma-modal-open')) return;

    scrollLockState.scrollY = window.scrollY;
    scrollLockState.htmlOverflow = document.documentElement.style.overflow;
    scrollLockState.bodyStyles = {
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
    };

    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('dharma-modal-open');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollLockState.scrollY}px`;
    document.body.style.width = '100%';
  }

  unlockScreen() {
    if (!document.body.classList.contains('dharma-modal-open')) return;

    const hasAnotherLockedModal = Array.from(document.querySelectorAll('dharma-modal[lock-screen][data-show="true"]'))
      .some((modal) => modal !== this);

    if (hasAnotherLockedModal) return;

    document.documentElement.style.overflow = scrollLockState.htmlOverflow;
    document.body.classList.remove('dharma-modal-open');
    document.body.style.overflow = scrollLockState.bodyStyles?.overflow || '';
    document.body.style.position = scrollLockState.bodyStyles?.position || '';
    document.body.style.top = scrollLockState.bodyStyles?.top || '';
    document.body.style.width = scrollLockState.bodyStyles?.width || '';
    window.scrollTo(0, scrollLockState.scrollY);
    scrollLockState.bodyStyles = null;
  }

  addButtonListeners() {
    if (!this.abortController) this.abortController = new AbortController();
    const { signal } = this.abortController;
    const btns = this.content?.querySelectorAll('button');
    //
    btns?.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        console.log(e);
        if (this.#contentType === 'confirm' || e.target.name === 'dismiss') this.dataset.show = 'false';
        this.dispatchCustomEvent(e.target.name || e.target.title);
      }, { signal });
    });
  }

  dispatchCustomEvent(name, otherData = {}) {
    Logger.info(`${this.#NAME} > #dispatchCustomEvent > ${name}`);
    const event = new CustomEvent('modalevent', {
      detail: {
        name,
        ...otherData
      },
    });
    this.dispatchEvent(event);
  }
}

customElements.define('dharma-modal', DharmaModal);
